












































import { Component, Prop, Vue } from "vue-property-decorator";
import { ITag } from "@/models/tags";
import { IBrand } from "@/models/brands";

@Component({
  components: {
    "tags-cloud-view": () =>
      import("@/components/app/global/tags/tagsCloudView.vue"),
    "tags-provider": () =>
      import("@/components/app/global/tags/tagsProvider.vue")
  }
})
export default class TagsSelectModal extends Vue {
  // Props

  @Prop({ required: true })
  public activeTags!: ITag[];

  @Prop({ required: true })
  public brandId!: IBrand["id"];

  // Data
  public isProcessing = false;
  public selectedTags: ITag[] = [];

  // Lifecycle methods
  public async created() {
    this.selectedTags = [...this.activeTags];
  }

  // Computed

  public get selectedTagIds() {
    return this.selectedTags.map(i => i.id).sort();
  }

  public get activeTagIds() {
    return this.activeTags.map(i => i.id).sort();
  }

  public get hasChange() {
    return !this.$_.isEqual(this.selectedTagIds, this.activeTagIds);
  }

  // Methods
  public toggleTag(tag: ITag) {
    const isSelected = this.selectedTags.find(i => i.id === tag.id);

    if (!isSelected) {
      this.selectedTags.push(tag);
    } else {
      // Reactivity is lost when used with some lodash functions like _.remove
      const index = this.selectedTags.findIndex(i => i.id === tag.id);
      this.selectedTags.splice(index, 1);
    }
  }

  public save() {
    this.$emit("success", this.selectedTags);
    this.$emit("close");
  }
}
